<template>
    <div>
        <div class="bookmark"></div>
        <div class="content-container">
            <choice-message
                    role="button"
                    v-bind:format="format"
                    v-bind:message="message"
            />
        </div>
    </div>
</template>

<script>
    import ChoiceMessage from './choice-message'

    export default {
        name: 'choice',
        components: {
            ChoiceMessage
        },
        props: {
            format: {
                type: String,
                required: true
            },
            message: {
                type: String,
                required: true
            }
        }
    }
</script>